import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SystemCode, TranslationRule } from '@helpers/types/models';
import { exist } from '@campaign-portal/namespace/common/id';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SystemCodesService } from '../system-codes.service';

@Component({
	selector: 'app-system-codes-dialog',
	templateUrl: './dialog.component.html',
	styleUrl: './dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SystemCodesDialogComponent {

	private readonly destroyRef = inject(DestroyRef);
	rules: TranslationRule[] = [];
	constructor(
			@Inject(DIALOG_DATA) public readonly data: { code: SystemCode<exist>, rules: TranslationRule[] },
			public readonly service: SystemCodesService,
			private readonly dialogRef: DialogRef<boolean>,
	) {
		this.rules = data.rules;
	}
	
	confirm(): void {
		this.service.delete({ id: this.data.code.id })
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if ( resp.success ) {
					this.dialogRef.close(true);
				}
			});
	}
	
	close(): void {
		this.dialogRef.close(false);
	}
}
